import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { TaxZoneStateClass } from './interfaces/taxZoneStateClass';
import { sortData } from '../../../common/timeLiveFunction';

const initialState: TaxZoneStateClass = {
    isLoading: false,
    status: 'idle',
    taxZoneList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'AccountTaxZone',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        taxZone: TaxZoneStateClass;
    },
}
export const getAccountTaxZoneAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'taxZone/getAccountTaxZone',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TaxZones', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getAccountTaxZoneByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxZone/getAccountTaxZoneById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TaxZones/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    
    export const addTaxZoneAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxZone/addTaxZone',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TaxZones/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateTaxZoneAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxZone/UpdateTaxZone',
        async (arg, thunkApi) => {
            const { AccountTaxZoneId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/TaxZones/' + AccountTaxZoneId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteTaxZoneAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'taxZone/deleteTaxZone',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/TaxZones/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
  

    export const deleteAllSelectedRecordTaxZoneAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordTaxZone",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/TaxZones/DeleteAllSelectedRecordTaxZone/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )



export const taxZoneSlice = createSlice({
    name: 'taxZone',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.taxZoneList.findIndex((item) => item.AccountTaxZoneId == action.payload);
            const newArray = [...state.taxZoneList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.taxZoneList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.taxZoneList.findIndex((item) => item.AccountTaxZoneId == action.payload);
            const newArray = [...state.taxZoneList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.taxZoneList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.taxZoneList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.taxZoneList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.taxZoneList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.taxZoneList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.taxZoneList;
            state.taxZoneList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountTaxZoneAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountTaxZoneAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.taxZoneList = payload.Data;
                state.taxZoneList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                
            })
            .addCase(getAccountTaxZoneAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
           .addCase(getAccountTaxZoneByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountTaxZoneByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getAccountTaxZoneByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addTaxZoneAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addTaxZoneAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addTaxZoneAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
           
            .addCase(updateTaxZoneAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateTaxZoneAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateTaxZoneAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteTaxZoneAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteTaxZoneAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteTaxZoneAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            
            .addCase(deleteAllSelectedRecordTaxZoneAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordTaxZoneAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedRecordTaxZoneAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting
} = taxZoneSlice.actions
 export const taxZoneStateClass = (state: RootState) => state.taxZone
 export default taxZoneSlice.reducer